import { defineStore } from 'pinia'
import type { Hero } from '~/types/general'

export const useThemeStore = defineStore({
    id: 'theme',
    state: () => ({
        theme: {
            primary: "#FF6C44",
            secondary: "#FFD633",
            tertiary: "#FF6C44",
            dark: "#000",
            light: "#FFF",
            accent: "#FF6C44",
            error: "#FF6C44",
            info: "#FF6C44",
            success: "#FF6C44",
            warning: "#FF6C44"
        },

        hero: {
            banner: "/images/hero-1.jpg",
            title: "Why Choose Us?",
            subtitle: [
                "Local owned and operated",
                "Zero commision, pay as  local travelers",
                "No deposit required, pay as you go",
                "Free cancellation, cancel anytime as you wish"
            ],
        }
    }),

    getters: {
        getHero(): Hero {
            return this.hero
        }
    }

})

